export const TWO_WEEKS = 12096e5;
